import React from "react";
import UserBalanceDetails from "../components/customers";
export function OverallActiveCustomers() {
  return (
    <div>
      <UserBalanceDetails />
    </div>
  );
}
export default OverallActiveCustomers;
